export const sanitizeEmail = (email?: string | null): string => {
    if (!email) return "";
    // making named wrapper in case we want to add other sanitization to how
    // we handle emails. Going to apply this func to every use of email to fix
    // some of the upper and lower case issues Ana has been noticing - Andrew
    return email?.toLowerCase().trim();
};
